import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useStampsList() {
  // Use toast
  const toast = useToast();

  const refStampListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    { key: "name", stickyColumn: true, label: "模版名稱", sortable: true },
    { key: "image_url", label: "印章圖片" },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const stampsList = ref(null);

  // const filter_stamp_type_id = ref(null);
  // const filter_project_id = ref(null);
  // const filter_customer_id = ref(null);
  // const filter_product_id = ref(null);
  // const filter_quotation_id = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refStampListTable.value
      ? refStampListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refStampListTable.value.refresh();
  };

  watch(
    [
      currentPage, perPage, searchQuery, 
      // filter_stamp_type_id, filter_project_id, filter_customer_id,
      // filter_product_id, filter_quotation_id
    ],
    () => {
      refetchData();
    }
  );

  const fetchStamps = (ctx, callback) => {

    store
      .dispatch("stamp/fetchStamps", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // stamp_type_id: filter_stamp_type_id.value,
        // quotation_id: filter_quotation_id.value,
        // project_id : filter_project_id.value,
        // customer_id: filter_customer_id.value,
        // product_id: filter_product_id.value
      })
      .then((response) => {
        const { stamps, total } = response.data;
        callback(stamps);
        totalRow.value = total;
        stampsList.value = stamps
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取印章清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // const stampTypeOptions = ref([]);
  // const quotationOptions = ref([]);
  // const customerOptions = ref([]);
  // const productOptions = ref([]);
  // const workerOptions = ref([]);
  // const projectOptions = ref([])

  // const refetchOption = () => {
  //   store
  //     .dispatch("app/fetchOptionList", {
  //       quotation_types: true,
  //       quotations: true,
  //       customers: true,
  //       products: true,
  //       projects: true,
  //     })
  //     .then((response) => {
  //       stampTypeOptions.value = response.data.quotation_types;
  //       quotationOptions.value = response.data.quotations;
  //       customerOptions.value = response.data.customers;
  //       productOptions.value = response.data.products;
  //       workerOptions.value = response.data.workers;
  //       projectOptions.value = response.data.projects;
  //     });
  // };

  onMounted(() => {
    // refetchOption();
  });

  return {
    fetchStamps,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    stampsList,
    refStampListTable,
    ability,
    refetchData,
    // filter_stamp_type_id,
    // filter_project_id,
    // filter_customer_id,
    // filter_product_id,
    // filter_quotation_id,
    // stampTypeOptions,
    // quotationOptions,
    // customerOptions,
    // productOptions,
    // workerOptions,
    // projectOptions,
  };
}
